export type Bonus = {
  number: string
  title: string
  body: string
  /** URL pública de la portada. Vacío = se muestra una portada diseñada de respaldo. */
  cover: string
  accent: string
}

/**
 * Los 5 bonus reales del pack (Bonus - DPS65 · Solar PV & Battery Diagnostic Pro).
 * Cuando estén los mockups (DPS65 - Bono 1..5), pegá la URL pública en `cover`.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 7-Day Quick Start',
    body: 'One short task a day for your first week with the pack, with a “start here” map for new techs, installers adding service and O&M owners. By day 7 you’ve run a real visit with the Split-and-Prove Path and your paperwork ready.',
    cover: '',
    accent: 'bg-ember',
  },
  {
    number: '02',
    title: 'Region Adapter: US, UK, Canada & Australia',
    body: 'The same fault has four names in four countries. Disconnect or isolator, ground or earth, GFCI or RCD, utility or DNO: field terms, equipment names, grid voltage and frequency, and conductor colours by country — so every card reads naturally wherever you work.',
    cover: '',
    accent: 'bg-sky',
  },
  {
    number: '03',
    title: 'Customer Leave-Behind Sheets',
    body: 'Plain-language one-pagers you hand over at the end of the visit, one per system type: what’s normal in the app, what happens in an outage, what not to do and the five signs it’s really time to call you. Space for your stamp and contact.',
    cover: '',
    accent: 'bg-moss',
  },
  {
    number: '04',
    title: 'PV & Battery Abbreviation Decoder',
    body: 'Every abbreviation on datasheets, labels, portals and BMS screens — Riso, RSD, MLPE, SOH, DoD, CT, LeTID, UL 1741 SB and more — decoded in one line, with what it means for your diagnosis.',
    cover: '',
    accent: 'bg-vol-3',
  },
  {
    number: '05',
    title: 'Fillable Worksheet Pack',
    body: 'All 40 worksheets as a fillable PDF you complete on your phone or tablet, save per customer and send as a PDF. No more filling paperwork on the roof or rewriting it at night.',
    cover: '',
    accent: 'bg-vol-5',
  },
]
